// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-1031f656]{color:#2c3a4b!important}.Whatsapp[data-v-1031f656]{background-color:#78d685}.instagram[data-v-1031f656]{background-color:#f04b67}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
